import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import auth from "../auth";

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // Suscripción al store: al hacerse logout (ej. por inactividad) re-renderiza y redirige al login
  useSelector((state) => state.general.isAuthenticated);

  if (auth.isAuthenticated()) {
    return children;
  } else {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }
};